import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import AnaSayfa from "../Pages/AnaSayfa";
import Contact from "../Pages/Contact";
import Egitimler from "../Pages/Egitimler";
import Ofislerimiz from "../Pages/Ofislerimiz";
import AnlasmaliKurumlar from "../Pages/AnlasmaliKurumlar";
import Etkinlikler from "../Pages/Etkinlikler";
import LoginPage from "../Pages/login";
import Register from "../Pages/register";
import Forgot from "../Pages/forgot";
import Profile from "../Pages/Profile";
import Maintenance from "../Pages/Maintenance";
import PaymentSuccess from "../Pages/PaymentSuccess";
import GiftCardPaymentSuccess from "../Pages/GiftCardPaymentSuccess";
import GiftCardPaymentFailure from "../Pages/GiftCardPaymentFailure";
import PaymentFailed from "../Pages/PaymentFailed";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import MemberShipAgreement from "../Pages/MemberShipAgreement";
import PaymentOk from "../Pages/PaymentOk";
import PaymentFail from "../Pages/PaymentFail";

import OdemeSonuc from "../Pages/OdemeSonuc";

// ✅ YENİ POSNET SİSTEMİ
import RegisterPosnet from "../Pages/PosnetRegister";
import PosnetPayment from "../Pages/posnetPayment";
import PaymentResult from "../Pages/PaymentResult";
import ClarificationText from "../Pages/ClarificationText";
import AfisOlusturucu from "../Pages/AfisOlusturucu";
import SoruGonder from "../Pages/SoruGonder";
import Faturalarim from "../Pages/Faturalarim";
import Cark from "../Pages/Cark";
import Yenile from "../Pages/Yenile";
import YenilemeRehberi from "../Pages/YenilemeRehberi";
import BelgeOnayPopup from "../Components/BelgeOnayPopup";

import Afisler from "../Pages/Afisler";
import KisiselTakvim from "../Pages/KisiselTakvim";

const GATracker = () => {
  const location = useLocation();

  useEffect(() => {
    const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;
    if (GA_TRACKING_ID && GA_TRACKING_ID !== "G-XXXXXXXXXX") {
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        width: "90%",
        maxWidth: "600px",
        backgroundColor: "rgba(15, 23, 42, 0.95)",
        backdropFilter: "blur(12px)",
        color: "#ffffff",
        padding: "20px",
        borderRadius: "16px",
        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
        zIndex: 99999,
        display: "flex",
        flexDirection: "column",
        gap: "15px",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        animation: "slideUp 0.5s ease-out",
        fontFamily: "system-ui, -apple-system, sans-serif"
      }}
    >
      <style>{`
        @keyframes slideUp {
          from { transform: translate(-50%, 100px); opacity: 0; }
          to { transform: translate(-50%, 0); opacity: 1; }
        }
      `}</style>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "15px" }}>
        <p style={{ margin: 0, fontSize: "14px", lineHeight: "1.6", color: "#e2e8f0" }}>
          Sitemizde size en iyi deneyimi sunabilmek, site trafiğini analiz etmek ve kişiselleştirilmiş içerik sunmak için çerezler kullanıyoruz. Detaylı bilgi için <a href="/Assets/PDF/cerezPolitikasi.pdf" target="_blank" rel="noopener noreferrer" style={{ color: "#10b981", textDecoration: "underline", fontWeight: "600" }}>Çerez Politikamızı</a> inceleyebilirsiniz.
        </p>
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
        <button
          onClick={handleAccept}
          style={{
            backgroundColor: "#10b981",
            color: "white",
            border: "none",
            padding: "10px 24px",
            borderRadius: "8px",
            fontSize: "14px",
            fontWeight: "600",
            cursor: "pointer",
            transition: "all 0.2s ease",
            boxShadow: "0 4px 12px rgba(16, 185, 129, 0.2)"
          }}
          onMouseEnter={(e) => e.target.style.opacity = "0.9"}
          onMouseLeave={(e) => e.target.style.opacity = "1"}
        >
          Kabul Et
        </button>
      </div>
    </div>
  );
};

const AppRouter = () => {
  // const [authorized, setAuthorized] = useState(false);

  // useEffect(() => {
  //   const auth = localStorage.getItem("maintenanceAuth");
  //   if (auth === "true") {
  //     setAuthorized(true);
  //   }
  // }, []);

  // if (!authorized) {
  //   return <Maintenance onLogin={() => setAuthorized(true)} />;
  // }

  return (
    <BrowserRouter>
      <GATracker />
      <CookieBanner />
      <BelgeOnayPopup />
      <Routes>
        <Route path="/" element={<AnaSayfa />} />

        {/* ========== AUTH ROUTES ========== */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/profil" element={<Profile />} />
        <Route path="/yenile" element={<Yenile />} />
        <Route path="/yenileme-rehberi" element={<YenilemeRehberi />} />
        <Route path="/faturalarim" element={<Faturalarim />} />
        <Route path="/afis-olusturucu" element={<AfisOlusturucu />} />
        <Route path="/cark" element={<Cark />} />
        <Route path="/afisler" element={<Afisler />} />
        <Route path="/takvim" element={<KisiselTakvim />} />
        <Route path="/forgot" element={<Forgot />} />

        {/* ========== REGISTER ROUTES ========== */}
        {/* ESKİ SİSTEM - Vakıf Katılım (Mevcut) */}
        {/* <Route path="/register" element={<Register />} /> */}

        {/* ✅ YENİ SİSTEM - Posnet */}
        <Route path="/register" element={<RegisterPosnet />} />

        {/* ========== POSNET PAYMENT ROUTES ========== */}
        {/* Normal Kayıt Ödemesi */}
        <Route path="/posnet-payment/:orderId" element={<PosnetPayment />} />

        {/* Hediye Kodu Ödemesi */}
        <Route
          path="/posnet-payment-gift/:orderId"
          element={<PosnetPayment />}
        />

        {/* Abonelik Yenileme Ödemesi */}
        <Route
          path="/posnet-payment-renewal/:orderId"
          element={<PosnetPayment />}
        />

        {/* Posnet Ödeme Sonuç Sayfası */}
        <Route path="/posnet-odeme-sonuc" element={<PaymentResult />} />

        {/* ========== INFO PAGES ========== */}
        <Route path="/iletisim" element={<Contact />} />
        <Route path="/gizlilik_politikasi" element={<PrivacyPolicy />} />
        <Route
          path="/gizlilik_politikasi/uyelik_satis_sozlesmesi"
          element={<MemberShipAgreement />}
        />
        <Route
          path="/iletisim_formu_aydinlatma_metni"
          element={<ClarificationText />}
        />
        <Route path="/soruGonder" element={<SoruGonder />} />


        {/* ========== EDUCATION ROUTES ========== */}
        <Route path="/egitimler" element={<Egitimler />} />
        <Route path="/egitimler/:slug1" element={<Egitimler />} />
        <Route path="/egitimler/:slug1/:slug2" element={<Egitimler />} />
        <Route path="/egitimler/:slug1/:slug2/:slug3" element={<Egitimler />} />
        <Route
          path="/egitimler/:slug1/:slug2/:slug3/:slug4"
          element={<Egitimler />}
        />
        <Route
          path="/egitimler/:slug1/:slug2/:slug3/:slug4/:slug5"
          element={<Egitimler />}
        />
        <Route
          path="/egitimler/:slug1/:slug2/:slug3/:slug4/:slug5/:slug6"
          element={<Egitimler />}
        />
        <Route
          path="/egitimler/:slug1/:slug2/:slug3/:slug4/:slug5/:slug6/:slug7"
          element={<Egitimler />}
        />

        {/* ========== OFFICE & PARTNER ROUTES ========== */}
        <Route path="/ofislerimiz" element={<Ofislerimiz />} />
        <Route path="/ofislerimiz/:slug" element={<Ofislerimiz />} />
        <Route
          path="/ofislerimiz/:slug/video/:videoId"
          element={<Ofislerimiz />}
        />
        <Route path="/anlasmali-kurumlar" element={<AnlasmaliKurumlar />} />
        <Route path="/anlasmali-kurumlar/:id" element={<AnlasmaliKurumlar />} />

        {/* ========== ESKİ ÖDEME SAYFALARI (Vakıf Katılım) ========== */}
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route
          path="/payment/gift-card/success"
          element={<GiftCardPaymentSuccess />}
        />
        <Route
          path="/payment/gift-card/failed"
          element={<GiftCardPaymentFailure />}
        />
        <Route path="/payment/failed" element={<PaymentFailed />} />

        <Route path="/payment/ok" element={<PaymentOk />} />
        <Route path="/payment/fail" element={<PaymentFail />} />

        <Route path="/odeme-sonuc" element={<OdemeSonuc />} />

        {/* ========== 404 REDIRECT ========== */}
        <Route path="*" element={<RedirectToHome />} />
      </Routes>
    </BrowserRouter>
  );

  function RedirectToHome() {
    window.location.replace(window.location.origin);
    return null;
  }
};

export default AppRouter;
